export default __webpack_public_path__ + "static/media/wordpress.9f65faf2.jpg";